import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    this.closestSection = closestSection;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.addEventListener('load', this.scheduleMediaHeight, true);
    window.addEventListener('resize', this.scheduleMediaHeight, { passive: true });
    this.mediaObserver = new MutationObserver(this.scheduleMediaHeight);
    this.mediaObserver.observe(this, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    this.scheduleMediaHeight();
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.removeEventListener('load', this.scheduleMediaHeight, true);
    window.removeEventListener('resize', this.scheduleMediaHeight);
    this.mediaObserver?.disconnect();
    cancelAnimationFrame(this.mediaHeightFrame);
  }

  // Fit the viewport to the current photo, rather than the tallest hidden slide.
  scheduleMediaHeight = () => {
    cancelAnimationFrame(this.mediaHeightFrame);
    this.mediaHeightFrame = requestAnimationFrame(() => {
      if (!this.isConnected) return;
      const gallery = this.querySelector('slider-component');
      const main = gallery?.querySelector('.product-media-gallery-main-slider');
      const track = main?.querySelector('.splide__track');
      if (!track) return;
      if (gallery.classList.contains('product-media-gallery--grid') && window.innerWidth > 750) {
        track.style.removeProperty('height');
        return;
      }
      const media = main.querySelector('.splide__slide.is-active .product-media');
      const height = media?.getBoundingClientRect().height;
      if (height > 0 && Math.abs(track.getBoundingClientRect().height - height) > 0.5) {
        track.style.height = height + 'px';
      }
    });
  };

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}

